module.exports = __webpack_public_path__ + "static/media/security-threatmetrix-white.a62a0723.svg";